// extracted by mini-css-extract-plugin
export var quillEditor = "_ng-1";
export var variable = "_ng-0";